import { useEffect, useRef } from "react";
import { ReactLenis } from "lenis/react";

export function SmoothScroll({ children }) {
  const ref = useRef(null);
  const disabled = typeof window !== "undefined" && window.location.search.includes("nolenis");

  useEffect(() => {
    if (disabled) return;
    const id = setInterval(() => {
      if (ref.current?.lenis) {
        window.lenis = ref.current.lenis;
        clearInterval(id);
      }
    }, 100);
    return () => clearInterval(id);
  }, [disabled]);

  if (disabled) return <>{children}</>;

  // Let Lenis smooth-scroll the page, but hand native wheel/touch scrolling back to
  // any explicitly-scrollable element (modals, dropdowns, the admin sidebar). Without
  // this, Lenis hijacks the wheel and inner scroll areas only move via their scrollbar.
  const prevent = (node) =>
    !!(node && node.closest && node.closest('[data-lenis-prevent], [role="dialog"], .overflow-y-auto, .overflow-auto'));

  return (
    <ReactLenis root ref={ref} options={{ lerp: 0.09, duration: 1.2, smoothWheel: true, prevent }}>
      {children}
    </ReactLenis>
  );
}
